import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {NotificationsStore} from './types';

export const useNotificationsStore = create<NotificationsStore>()(
	persist(
		(set, get) => ({
			readNotifications: {},

			markAsRead: id =>
				set(state => ({
					readNotifications: {
						...state.readNotifications,
						[id]: true,
					},
				})),

			isRead: id => Boolean(get().readNotifications[id]),
		}),
		{
			name: 'notifications-storage',
		},
	),
);
